import { createAction, props } from '@ngrx/store';

export const fetchBillingProfile = createAction(
  '[Billing Profile] Fetch'
);

export const fetchBillingProfileSuccess = createAction(
  '[Billing Profile] Fetch Success',
  props<{ data: any }>()
);

export const fetchBillingProfileFailure = createAction(
  '[Billing Profile] Fetch Failure',
  props<{ error: any }>()
);

export const submitBillingProfile = createAction(
  '[Billing Profile] Submit',
  props<{ billingProfile: any }>()
);

export const submitBillingProfileSuccess = createAction(
  '[Billing Profile] Submit Success',
  props<{ billingProfile: any }>()
);

export const submitBillingProfileFailure = createAction(
  '[Billing Profile] Submit Failure',
  props<{ error: any }>()
);

export const updateBillingProfile = createAction(
  '[Billing Profile] Update',
  props<{ id: number, billingProfile: any }>()
);

export const updateBillingProfileSuccess = createAction(
  '[Billing Profile] Update Success',
  props<{ billingProfile: any }>()
);

export const updateBillingProfileFailure = createAction(
  '[Billing Profile] Update Failure',
  props<{ error: any }>()
);

export const deleteBillingProfile = createAction(
  '[Billing Profile] Delete',
  props<{ id: number }>()
);

export const deleteBillingProfileSuccess = createAction(
  '[Billing Profile] Delete Success',
  props<{ id: number }>()
);

export const deleteBillingProfileFailure = createAction(
  '[Billing Profile] Delete Failure',
  props<{ error: any }>()
);
